<template>
  <div class="topfans-page-contact">
    <div class="topfans-section app-basic-layout-wrapper">
      <h3 class="title font-30">关注我们查看更多产品信息</h3>
      <p class="subtitle">关注官方微博账号，查看最新优惠政策信息</p>
      <div class="body">
        <div class="cards-wrapper">
          <a href="https://weibo.com/u/3587960280" target="_blank" class="card">
            <div class="avatar">
              <img src="@/assets/img/topfans/weibo_avatar.png" alt="" />
              <div class="vip-icon">
                <i class="iconfont icon-yonghushuxing"></i>
              </div>
            </div>
            <div class="text-wrapper">
              <h3 class="font-20">粉丝头条官方微博</h3>
              <p class="font-13">关注获取更多营销信息和精彩内容</p>
            </div>
          </a>
          <a href="https://weibo.com/u/2432996365" target="_blank" class="card">
            <div class="avatar">
              <img src="@/assets/img/topfans/kefu_avatar.png" alt="" />
              <div class="vip-icon">
                <i class="iconfont icon-yonghushuxing"></i>
              </div>
            </div>
            <div class="text-wrapper">
              <h3 class="font-20">微博企业商业客服</h3>
              <p class="font-13">更多使用咨询</p>
            </div>
          </a>
          <div class="tel-wrapper app-flex-column">
            <span class="label">或者直接拨打</span>
            <i class="line"></i>
            <h3 class="tel font-42 font-color-danger">4000-980-980</h3>
            <span class="time font-14 font-color-desc">
              周一至周日 9:00-18:00
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topfans-page-contact'
}
</script>

<style lang="scss" scoped>
.topfans-page-contact {
  .subtitle {
    margin-bottom: 60px;
  }
  .cards-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .card {
    display: flex;
    width: 376px;
    height: 144px;
    padding: 44px;
    border-radius: 4px;
    border: 1px solid #efeff3;
    box-sizing: border-box;
    color: $text-color-default;
    align-items: center;
    .avatar {
      width: 56px;
      height: 56px;
      border: 2.8px solid #efeff3;
      border-radius: 50%;
      margin-right: 16px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        float: left;
      }
    }
    .text-wrapper {
      display: flex;
      height: 56px;
      flex: 1;
      flex-direction: column;
      justify-content: space-around;
      p {
        color: $text-color-notice;
      }
    }
    .vip-icon {
      position: absolute;
      width: 18px;
      height: 18px;
      text-align: center;
      line-height: 18px;
      border-radius: 50%;
      background-color: #2fb0f7;
      color: #ffffff;
      bottom: -6px;
      right: -6px;
      border: 3px solid #ffffff;
      i {
        font-size: 18px;
      }
    }
    &:hover {
      border-color: transparent;
      box-shadow: 0 8px 13px rgba(0, 0, 0, 0.1);
    }
  }
  .tel-wrapper {
    width: 303px;
    margin-left: 69px;
    .line {
      width: 64px;
      height: 4px;
      background: $neutral-color-3;
      border-radius: 2px;
      margin-top: 12px;
      margin-bottom: 16px;
    }
    .tel {
      margin-bottom: 8px;
    }
  }
}
</style>
